import React from 'react';
import { Text, useTheme } from '@fluentui/react';
import { EnvironmentFeatures } from '../../models/CloudStatusModels';

interface FeaturesTabProps {
    features?: EnvironmentFeatures;
}

export const FeaturesTab: React.FC<FeaturesTabProps> = ({ features }) => {
    const theme = useTheme();

    return (
        <div
            style={{
                paddingTop: '16px',
                width: '100%',
            }}
        >
            <div
                style={{
                    backgroundColor: theme.palette.neutralTertiaryAlt,
                    borderRadius: '4px',
                    border: `1px solid ${theme.palette.neutralTertiary}`,
                    padding: '24px',
                    boxShadow:
                        '0 1.6px 3.6px 0 rgba(0, 0, 0, .132), 0 .3px .9px 0 rgba(0, 0, 0, .108)',
                    margin: '0 auto',
                }}
            >
                <Text
                    variant="xLarge"
                    styles={{
                        root: {
                            fontWeight: 700,
                            color: theme.palette.black,
                            marginBottom: '24px',
                            display: 'block',
                        },
                    }}
                >
                    Available Features
                </Text>

                {features && (
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns:
                                'repeat(auto-fill, minmax(280px, 1fr))',
                            gap: '16px',
                        }}
                    >
                        {Object.entries(features).map(([key, value]) => {
                            const featureName = key
                                .replace(/([A-Z])/g, ' $1')
                                .replace(/^./, (str) => str.toUpperCase())
                                .trim();

                            const isEnabled = value === true;

                            return (
                                <div
                                    key={key}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '12px 16px',
                                        backgroundColor: theme.palette.white,
                                        borderRadius: '4px',
                                        border: `1px solid ${theme.palette.neutralLight}`,
                                        boxShadow:
                                            '0 1.6px 3.6px 0 rgba(0, 0, 0, .08)',
                                    }}
                                >
                                    <Text
                                        variant="medium"
                                        styles={{
                                            root: {
                                                fontWeight: 500,
                                                color: theme.palette
                                                    .neutralPrimary,
                                            },
                                        }}
                                    >
                                        {featureName}
                                    </Text>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                color: isEnabled
                                                    ? theme.palette.greenDark
                                                    : theme.palette
                                                          .neutralTertiary,
                                            }}
                                        >
                                            {isEnabled ? '✓' : '✗'}
                                        </span>
                                        <Text
                                            variant="medium"
                                            styles={{
                                                root: {
                                                    fontWeight: 600,
                                                    color: isEnabled
                                                        ? theme.palette
                                                              .greenDark
                                                        : theme.palette
                                                              .neutralTertiary,
                                                },
                                            }}
                                        >
                                            {isEnabled ? 'Enabled' : 'Disabled'}
                                        </Text>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {!features && (
                    <div
                        style={{
                            padding: '48px 24px',
                            textAlign: 'center',
                            backgroundColor: theme.palette.neutralLighterAlt,
                            borderRadius: '4px',
                        }}
                    >
                        <Text
                            variant="large"
                            styles={{
                                root: {
                                    color: theme.palette.neutralSecondary,
                                    fontStyle: 'italic',
                                },
                            }}
                        >
                            No feature information available
                        </Text>
                    </div>
                )}
            </div>
        </div>
    );
};
